import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { PipesModule } from '../pipes/pipes.module';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { GridsterModule } from 'angular-gridster2';
import { HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { CRMLastUsedModule } from '../components/widgets/wp-last-used/crm-lastUsed.module';
import { MoreUsedModule } from '../components/widgets/wp-more-used/more-used.module';
import { DynamicWidgetsComponent } from '../components/dynamic-widgets/dynamic-widgets.component';
import { UserProjectsModule } from '../components/widgets/user-projects/user-projects.module';
import { PartySearchModule } from '@neworg/party-search';
import { EmployeeCausalRequestListModule } from '@neworg/employee-causal-request-list'
import { UserActivitiesModule } from '../components/widgets/user-activities/user-activities.module';
import { LastUsedTemplateModule } from '../components/widgets/sa-last-used/last-used.module';
import { PartySharedLastDocumentsModule } from '@neworg/party-shared-lastdocuments';
import { PrimeNGModule } from './primeng.module';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppStateHolder } from './app-state.holder';
import { Interceptor } from './interceptor';
import { AuthExpiredInterceptor } from './auth-expired.interceptor';
import { TimeLine } from './time-line/time-line';
import { MsalSilentInterceptor } from './msal-silent.interceptor';
import { SupportComponent } from '../components/support/support.component';
import { UserMenuComponent } from '../components/user-menu/user-menu.component';
import { PartyProfilerModule } from '../components/widgets/party-profiler/party-profiler.module';
import { PartyAccrualsModule } from '@neworg/party-accruals';
import { AttendanceSheetLulSummaryModule } from '@neworg/attendancesheet-lul-summary'
import { PartyClockingDayModule } from '@neworg/party-clocking-day';
import { ClockingEntryModule } from '@neworg/clocking-entry'
import { SmartBoxV2Component } from '../components/smart-box-v2/smart-box-v2.component';
import { AmCopilotComponent } from '../components/am-copilot/am-copilot.component';
import { MarkdownModule } from 'ngx-markdown';
import { AmSuiteAssistantBotModule } from '@neworg/amsuite-assistant-bot';

import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { AlertComponent } from '../components/alert/alert.component';
import { Accordion } from 'primeng/accordion';

@NgModule({
  imports: [
    PrimeNGModule,
    MarkdownModule.forChild(),
    CommonModule,
    CRMLastUsedModule,
    MoreUsedModule,
    UserProjectsModule,
    PartyProfilerModule,
    UserActivitiesModule,
    PartySharedLastDocumentsModule,
    AttendanceSheetLulSummaryModule,
    EmployeeCausalRequestListModule,
    PartyAccrualsModule,
    IconFieldModule,
    InputIconModule,
    GridsterModule,
    LastUsedTemplateModule,
    PartyClockingDayModule,
    ReactiveFormsModule,
    FormsModule,
    ClockingEntryModule,
    AmSuiteAssistantBotModule,
    PipesModule,
    TranslateModule,
    PartySearchModule,
    DynamicWidgetsComponent,
    SupportComponent,
    UserMenuComponent,
    SmartBoxV2Component,
    AmCopilotComponent,
    AlertComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalSilentInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: Interceptor,
      multi: true
    },
    AppStateHolder,
    TimeLine,
    ConfirmationService,
    Accordion,
    MessageService,
  ],
  exports: [
    PrimeNGModule,
    CommonModule,
    CRMLastUsedModule,
    MoreUsedModule,
    PartyProfilerModule,
    AttendanceSheetLulSummaryModule,
    UserProjectsModule,
    UserActivitiesModule,
    PartySharedLastDocumentsModule,
    PartyAccrualsModule,
    EmployeeCausalRequestListModule,
    GridsterModule,
    LastUsedTemplateModule,
    PartyClockingDayModule,
    ReactiveFormsModule,
    ClockingEntryModule,
    AmSuiteAssistantBotModule,
    FormsModule,
    IconFieldModule,
    InputIconModule,
    PipesModule,
    TranslateModule,
    PartySearchModule,
    DynamicWidgetsComponent,
    AmCopilotComponent,
    AlertComponent,
    SmartBoxV2Component,
    SupportComponent,
    UserMenuComponent
  ],
})
export class SharedModule { }

